import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Allow access to mdt-login without admin role (for initial MDT authentication)
  const fullPath = route.url.map(s => s.path).join('/');
  if (fullPath === 'admin' || route.routeConfig?.path === 'mdt-login' || route.routeConfig?.path === '') {
    // Check if user is at least logged in
    if (authService.isAdmin()) {
      return true;
    }
    // For mdt-login, allow access if user is logged in (not necessarily admin)
    if (authService.isAuthenticated()) {
      return true;
    }
    router.navigate(['/login']);
    return false;
  }

  // For all other admin routes, require admin role
  if (authService.isAdmin()) {
    return true;
  }

  router.navigate(['/admin/mdt-login']);
  return false;
};
